import { createApp } from 'vue'
import VueMatomo from 'vue-matomo'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/css/common.css'
import locale from 'element-plus/es/locale/lang/zh-cn'

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});

let host = window.location.host;
let dev = host.split('.')[1]
let accountDomain = ''
let domain = '';
let hostDomain = '';
if (host.includes('-p')) {
  accountDomain = 'https://account-p.console.landui.com'
  hostDomain = "https://rds-p.console.landui.com";
  domain = 'https://p.landui.com'
} else if (host.includes('.st')) {
  accountDomain = 'https://account.st.landui.cn'
  hostDomain = "https://rds.st.landui.cn";
  domain = 'https://www.st.landui.cn'
} else if (host.includes('localhost')) {
  accountDomain = 'http://account.wcy.dev.landui.cn'
  hostDomain = "https://rds.st.landui.cn";
  domain = 'https://www.st.landui.cn';
} else if (host.includes('dev')) {
  accountDomain = 'http://account.' + dev + '.dev.landui.cn'
  hostDomain = "https://rds.st.landui.cn";
  domain = "http://www."+dev+".dev.landui.cn";
} else {
  accountDomain = 'https://account.console.landui.com'
  hostDomain = "https://rds.console.landui.com";
  domain = 'https://www.landui.com'
}


const app = createApp(App)
app.provide('domain', domain)
app.provide('hostDomain', hostDomain)
app.provide('accountDomain', accountDomain)

app.use(VueMatomo, {
  host: '//analytics.landui.com',
  siteId: 1
})
app.use(router)
app.use(store)
app.use(ElementPlus, { locale });
app.mount('#app')
window._paq.push(['trackPageView'])